<template>
  <div class="addAppointment">
    <div v-show="addAppointment">
      <van-sticky>
        <div class="header">
          <van-icon name="arrow-left" color="#fff" class="vanIcon" @click="returnIndex" />
          <span class="addInfo">预约草稿箱修改</span>
        </div>
      </van-sticky>
      <!-- 添加预约表单 -->
      <div ref="deptSort">
        <van-form :v-model="form">
          <div class="appointTop">
            <div>
              <div class="appointInfo">客人:</div>
              <input type="text" placeholder="请输入名字" v-model="form.customerName" />
            </div>
            <div>
              <div class="appointInfo">卡号:</div>
              <input type="text" maxlength="50" placeholder="请输入卡号" v-model="form.cadCode" />
            </div>
            <div>
              <div class="appointInfo">手机号:</div>
              <input type="text" maxlength="50" placeholder="请输入手机号" v-model="form.mobile" />
            </div>
            <van-button style="width:90%;margin:10px 0" type="danger" round color=" #0297CE"
              @click="getInfo">获取信息</van-button>
            <div>
              <div class="appointInfo">预约就诊时间:</div>
              <div class="selfSelect">
                <van-field readonly clickable name="datetimePicker" :value="form.appointmentTime" placeholder="请选择"
                  @click="showPicker = true" />
                <van-popup v-model="showPicker" position="bottom">
                  <van-datetime-picker v-model="dateTime" title="请选择时间" type="datetime" @confirm="onConfirm"
                    @cancel="showPicker = false" :formatter="formatter" @change="changePre" />
                </van-popup>
              </div>
            </div>
            <div>
              <div class="appointInfo">项目类型:</div>
              <div class="selfSelect">
                <van-field readonly clickable name="datetimePicker" placeholder="请选择项目类型" v-model="form.projectTypeName"
                  @click="typeShow = true;" />
                <van-action-sheet v-model="typeShow" :actions="actionsType" @select="onSelectType" />
              </div>
            </div>
          </div>
          <div class="appointBottom" v-for="(item, index) in form.AppointmentProject" :key="index">
            <van-cell-group class="arrowLine">
              <!-- <van-field v-model="item.areaName" label="院区:" disabled @click="checkArea(index);showArea = true;" /> -->
              <van-field v-model="item.areaName" label="院区:" disabled @click="checkArea(index);" />
              <van-icon name="arrow" color="#2765C7" />
              <van-action-sheet v-model="showArea" :actions="actionsArea" @select="onArea" />
            </van-cell-group>
            <van-cell-group class="arrowLine">
              <van-field v-model="item.floorName" label="楼层:" disabled @click="checkFloor(index);" />
              <van-icon name="arrow" color="#2765C7" />
              <van-action-sheet v-model="showFloor" :actions="actionsFloor" @select="onFloor" />
            </van-cell-group>
            <van-cell-group class="arrowLine">
              <van-field v-model="item.projectName" label="项目选择:" disabled @click="enterPart(4, index)" />
              <van-icon name="arrow" color="#2765C7" />
            </van-cell-group>
            <van-cell-group class="arrowLine">
              <van-field v-model="item.hmProjectName" label="宏脉项目名称" disabled />
            </van-cell-group>
            <van-cell-group class="arrowLine">
              <van-field v-model="item.instrumentName" label="仪器:" disabled @click="enterPart(0, index)" />
              <van-icon name="arrow" color="#2765C7" />
            </van-cell-group>
            <div v-for="(domain, idx) in item.appointmentPosition " :key="idx">
              <van-cell-group class="arrowLine">
                <van-field v-model="domain.positionNameTime" :label="'部位' + (idx + 1) + ':'" disabled
                  @click="enterPart(1, index, idx)" />
                <van-icon name="arrow" color="#2765C7" />
                <van-icon name="delete-o" color="#F56C6C" @click.prevent="removeDomain(domain, idx, index)"
                  v-show="idx > 0" />
              </van-cell-group>
            </div>
            <van-cell-group class="arrowLine addArrow">
              <van-field disabled />
              <van-button type="danger" size="mini" round color=" #0297CE" @click="addDomain(index)">新增部位</van-button>
            </van-cell-group>
            <van-cell-group class="arrowLine">
              <van-field v-model="item.doctorName" label="操作人:" disabled @click="enterPart(2, index)" />
              <van-icon name="arrow" color="#2765C7" />
            </van-cell-group>
            <van-cell-group class="arrowLine">
              <van-field v-model="item.appointStatusList" label="初/复诊:" disabled @click="check(index); show = true;" />
              <van-icon name="arrow" color="#2765C7" />
              <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
            </van-cell-group>
            <van-cell-group>
              <van-field v-model="item.remark" label="备注:" />
            </van-cell-group>
            <p class="split"></p>
            <van-button class="dangerButton" type="danger" size="mini" round color="#F56C6C " v-show="index > 0"
              @click="deleteItems(item, index)">删除项目</van-button>
          </div>
          <div style="margin: 16px">
            <div class="addProject" @click="addProject">添加项目</div>
            <div class="addProject" @click="addDraft">添加至草稿箱</div>
            <div class="sureMeet" @click="sureSubmit">确认预约</div>
          </div>
        </van-form>
      </div>
    </div>

    <!-- 选择项目内容 -->
    <div class="selectPart" v-show="!addAppointment">
      <div class="vanIndexBar" v-if="flag">
        <van-sticky>
          <div class="header">
            <div class="headerIcon">
              <van-icon name="arrow-left" color="#fff" @click="returnIndexList" />
              <van-search v-model="value" :placeholder="placeholderValue" @input="searchInput" />
            </div>
          </div>
        </van-sticky>
        <div class="commonBottom">
          <van-index-bar :sticky-offset-top="stickyOffset" highlight-color="#108EE9">
            <div v-for="(item, index) in textList" :key="index">
              <van-index-anchor :index="item.length != 0 ? index : ''" />
              <van-radio-group v-model="radio">
                <van-cell-group v-for="(list, index) in item" :key="index">
                  <van-cell :title="list.projectName" clickable @click="radio = list.projectId">
                    <template #right-icon>
                      <van-radio :name="list.projectId" />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
            </div>
          </van-index-bar>
        </div>
        <div class="textSure" @click="sureAdd()">
          <div class="selectSure">确定</div>
        </div>
      </div>
      <!-- 选择仪器 -->
      <div class="vanIndexBar" v-if="flag1">
        <van-sticky>
          <div class="header">
            <div class="headerIcon">
              <van-icon name="arrow-left" color="#fff" @click="returnIndexList" />
              <van-search v-model="value1" :placeholder="placeholderValue" />
            </div>
          </div>
        </van-sticky>
        <div class="commonBottom">
          <van-radio-group v-model="instrucRadio">
            <van-cell-group v-for="(list, index) in instrucmentList" :key="index">
              <van-cell :title="list.instrumentName" clickable @click="
                instrucRadio = list.instrumentId; instrucRadioList = list.instrumentName;">
                <template #right-icon>
                  <van-radio :name="list.instrumentId" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
        <div class="textSure" @click="addInstrucment();">
          <div class="selectSure">确定</div>
        </div>
      </div>
      <!-- 选择操作人 -->
      <div class="vanIndexBar" v-if="flag2">
        <van-sticky>
          <div class="header">
            <div class="headerIcon">
              <van-icon name="arrow-left" color="#fff" @click="returnIndexList" />
              <van-search v-model="value2" :placeholder="placeholderValue" />
            </div>
          </div>
        </van-sticky>
        <div class="commonBottom">
          <van-radio-group v-model="doctorRadio">
            <van-cell-group v-for="(list, index) in doctorList" :key="index">
              <van-cell :title="list.doctorName" clickable
                @click="doctorRadio = list.doctorId; doctorRadioList = list.doctorName">
                <template #right-icon>
                  <van-radio :name="list.doctorId" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
        <div class="textSure" @click="addDoctor()">
          <div class="selectSure">确定</div>
        </div>
      </div>
      <!-- 选择部位 -->
      <div v-if="flag3" style="margin-bottom:10rem;">
        <van-sticky>
          <div class="header">
            <div class="headerIcon">
              <van-icon name="arrow-left" color="#fff" @click="returnIndexList" />
              <van-search v-model="value2" :placeholder="placeholderValue" />
            </div>
          </div>
        </van-sticky>
        <van-radio-group v-model="positionRadio">
          <van-cell-group v-for="(list, index) in positionList" :key="index">
            <van-cell :title="list.positionName + '~' + list.useMinute + '分钟'" clickable
              @click="positionRadio = list.positionId; positionRadioList = list.positionName;">
              <template #right-icon>
                <van-radio :name="list.positionId" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-popup v-model="showInstrucmentTime" position="bottom">
          <van-datetime-picker :filter="filter" v-show="dateFlag" v-model="positionDateTime" title="请选择时间" type="datetime"
            @confirm="positionTime" @cancel="showInstrucmentTime = false" :formatter="formatter" />
          <van-datetime-picker v-show="!dateFlag" v-model="positionDateTime" title="请选择时间" type="datehour"
            @confirm="positionTime" @cancel="showInstrucmentTime = false" :formatter="formatter" />
        </van-popup>
        <div v-if="showTime">
          <van-dropdown-menu :class="valueLabel == 1 ? 'tips' : 'tooltips'">
            <van-dropdown-item v-model="valueLabel" :options="option1" />
          </van-dropdown-menu>
          <div v-if="valueLabel == 0">
            <div v-for="(list, index) in successAppointTime.occupied" :key="index" class="listData">
              <van-tag type="danger" round>{{ list.instrumentDate }}</van-tag>
            </div>
          </div>
          <div v-if="valueLabel == 1">
            <div v-for="(list, index) in successAppointTime.unoccupied" :key="index" class="listData">
              <van-tag type="primary" round>{{ list.instrumentDate }}</van-tag>
            </div>
          </div>
        </div>
        <div class="textSure" @click="addposition()">
          <div class="selectSure">确定</div>
        </div>
      </div>
      <!-- 选择客户信息 -->
      <div v-if="flag4" style="margin-bottom:10rem;">
        <info @reBack="reBack"></info>
      </div>
    </div>
  </div>
</template>
<script>
let pinyin = require('js-pinyin');
import { ContactCard, Dialog } from 'vant';
import axios from "axios"
import {
  findByProjectIdList,
  findProjectBydId,
  insertOrUpdateAppointment,
  findInstrumentFlag,
  findInstrumentDateById,
  findDoctorByInstrumentDate,
  findInstrumentById,
  saveAppointmentDrafts,
  findAppointmentDrafts,
  findDistinguishData,
  getClientInformation
} from "@/axios/api";
import info from './info.vue';
export default {
  components: { info },
  data() {
    return {
      form: {
        AppointmentProject: [{
          projectName: "",
          instrumentName: "",
          doctorName: "",
          operationStatus: "",
          appointStatus: "",
          projectInstrument: [],
          projectDoctor: [],
          remark: "",
          positionNameTime: '',
          appointmentPosition: [{
            positionId: '',
            useTime: '',
            positionName: '',
            positionNameTime: "",

          }],
        },],
      },
      showPicker: false,
      time: "",
      value: "",
      value1: "",
      value2: "",
      radio: "",
      addAppointment: true,
      projectIndex: "",
      projectItem: "",
      dateTime: new Date(),
      positionDateTime: new Date(),
      show: false,
      showFloor: false,
      showArea: false,
      actions: [{
        name: "初诊",
        id: 0,
      },
      {
        name: "复诊",
        id: 1,
      },
      {
        name: "VIP",
        id: 2,
      },
      ],
      checkIndex: "",
      flag: false,
      flag1: false,
      flag2: false,
      flag3: false,
      flag4: false,
      lists: [],
      textList: [],
      stickyOffset: 62,
      projectData: [],
      instrucmentList: [],
      instrucRadio: "",
      doctorList: [],
      positionList: [],
      positionRadio: '',
      positionRadioList: '',
      doctorRadio: "",
      showInstrucmentTime: false,
      placeholderValue: "",
      scrollTop: "",
      timeArr: [],
      FirstPin: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "#"
      ],
      projectIdx: '',
      areaIndex: '',
      floorIndex: '',
      showTime: false,
      successAppointTime: '',
      actionsFloor: [{
        name: "2楼",
        id: '2',
      }, {
        name: "3楼",
        id: '3',
      },
      {
        name: "12楼",
        id: '12',
      },
      ],
      actionsArea: [{
        name: "伯思立",
        id: 'bsl',
      }, , {
        name: "翡立思",
        id: 'fls',
      },],
      draftsId: '',
      valueLabel: 1,
      option1: [
        { text: '当日已预约时间', value: 0 },
        { text: '当日可预约时间', value: 1 },
      ],
      typeShow: false,
      actionsType: [{
        id: '1',
        name: '皮肤'
      }, {
        id: '2',
        name: '注射'
      }, {
        id: '3',
        name: '其他'
      }],
      dateFlag: true,
      areaType: localStorage.getItem('areaType')
    };
  },
  created() {
    console.log(this.$route.query)
    this.findDrafts(this.$route.query.relationId)
    this.draftsId = this.$route.query.id
  },
  methods: {
    getInfo() {
      if (this.form.cadCode == '' && this.form.mobile == '') {
        _g.toast("warning", '请填写手机号或卡号');
        return;
      }
      this.loadOption = []
      localStorage.setItem("selected", 1)
      this.loading = true
      let data = {
        clientCard: this.form.cadCode,
        clientMobile: this.form.mobile,
        clientName: this.form.customerName,
        pageIndex: 1,
      }

      getClientInformation(data)
        .then((res) => {
          console.log(res)
          if (res.result == true) {
            this.loading = false
            if (res.data.mapList.length == 1) {
              this.form.mobile = res.data.mapList[0].clientMobile
              this.form.cadCode = res.data.mapList[0].clientCard
              this.form.customerName = res.data.mapList[0].clientName
              this.$forceUpdate()
            } else {
              this.flag = false;
              this.flag1 = false;
              this.flag2 = false;
              this.flag3 = false;
              this.flag4 = true;
              this.addAppointment = false;
              this.loadOptions = res.data.mapList
            }
          } else if (res.result == false) {
            this.loading = false
            //   获取信息之后是否可以编辑信息
            this.disabled = false
            _g.toast("warning", '请手动添加客户信息');
          }
        }).catch((err) => {
          this.loading = false
        })
    },
    reBack(obj) {
      console.log(obj);
      this.flag = false;
      this.flag1 = false;
      this.flag2 = false;
      this.flag3 = false;
      this.flag4 = false;
      this.addAppointment = true;
      if (obj) {
        this.form.customerName = obj.clientName
        this.form.mobile = obj.clientMobile
        this.form.cadCode = obj.clientCard
      }

    },
    check(val) {
      console.log(val);
      this.checkIndex = val;
    },
    // 预约时间修改后清空数据
    changePre() {
      this.form.AppointmentProject = [{
        projectName: "",
        instrumentName: "",
        doctorName: "",
        operationStatus: "",
        appointStatus: "",
        projectInstrument: [],
        projectDoctor: [],
        remark: "",
        positionNameTime: '',
        appointmentPosition: [{
          positionId: '',
          useTime: '',
          positionName: '',
          positionNameTime: '',
        }],
      },]
    },
    // 添加预约返回首页
    returnIndex() {
      if ((!this.form.customerName || this.form.customerName == "") && (!this.form.mobile || this.form.mobile == "") && (!this.form.appointmentTime || this.form.appointmentTime == "")) {
        this.$router.push("/darftList");
      } else {
        Dialog.confirm({
          message: '是否保存至草稿箱？',
        }).then(() => {
          this.addDraft()
        }).catch(() => {
          this.$router.push("/darftList");
        });
      }

    },
    // 草稿箱回显
    findDrafts(relationId) {
      findAppointmentDrafts({
        relationId: relationId,
      })
        .then((res) => {
          console.log(res.data)
          if (res.result == true) {
            this.form.mobile = res.data[0].mobile
            this.form.customerName = res.data[0].customerName
            this.form.appointmentTime = res.data[0].appointmentTime
            if (res.data[0].projectType == '1') {
              this.form.projectTypeName = '皮肤'
              this.form.projectType = '1'
            } else if (res.data[0].projectType == '2') {
              this.form.projectTypeName = '注射'
              this.form.projectType = '2'
            } else if (res.data[0].projectType == '3') {
              this.form.projectTypeName = '其他'
              this.form.projectType = '3'
            }
            let newData = res.data
            newData.forEach(ele => {
              ele.appointmentPosition = []
              ele.projectDoctor = [
                { doctorId: '' }
              ]
              ele.projectInstrument = [
                { instrumentId: "" }
              ]
              if (ele.appointStatus == 2) {
                ele.appointStatusList = 'VIP'
              } else if (ele.appointStatus == 1) {
                ele.appointStatusList = '复诊'
              } else if (ele.appointStatus == 0) {
                ele.appointStatusList = '初诊'
              }

              ele.id = ele.projectId
              ele.projectInstrument[0].instrumentId = ele.instrumentId.slice(0, ele.instrumentId.length - 1)
              ele.projectDoctor[0].doctorId = ele.doctorId.slice(0, ele.doctorId.length - 1)
              // console.log('ele.positionId')
              // console.log(ele.positionId)
              if (ele.positionId != '' || ele.positionId) {
                // console.log('000000000')
                let newStr = ele.positionId.slice(0, ele.positionId.length - 1)
                let newArr = newStr.split(',')
                newArr.forEach((ite, index) => {
                  let str = ite.split('_')
                  var obj = {}
                  obj.positionId = str[0]
                  obj.positionName = str[1]
                  obj.useTime = str[2]
                  obj.positionNameTime = str[1] + '(' + str[2].split(' ')[1] + ')'
                  ele.appointmentPosition.push(obj)
                });
              }
            });
            this.form.AppointmentProject = newData
          }
          if (this.areaType == 'bsl') {
            this.form.AppointmentProject.forEach(item => {
              item.areaName = '伯思立'
            });
          } else if (this.areaType == 'fls') {
            this.form.AppointmentProject.forEach(item => {
              item.areaName = '翡立思'
              item.floorName = '1楼'
              item.floorCode = '1'
            });
          } else if (this.areaType == 'ntbsl') {
            this.form.AppointmentProject.forEach(item => {
              item.areaName = '南通伯思立'
              item.floorName = '1楼'
              item.floorCode = '1'
            });
          }
        })
    },
    /*删除新增的表单项*/
    deleteItems(item, index) {
      this.index = this.form.AppointmentProject.indexOf(item);
      if (index !== -1) {
        this.form.AppointmentProject.splice(index, 1);
      }
    },
    // 时间戳转换成日期
    getDate(timetamp) {
      //let myDate = new Date()如果是要获取当前时间的显示就不传参数
      let myDate = new Date(timetamp); //获取js时间
      let year = myDate.getFullYear(); //获取年
      let month = myDate.getMonth() + 1; //获取月
      let date = myDate.getDate(); //获取日
      let h = myDate.getHours(); //获取小时数(0-23)
      let m = myDate.getMinutes(); //获取分钟数(0-59)
      let s = myDate.getSeconds();
      //获取当前时间连接成的字符串
      let now =
        year +
        "-" +
        this.conver(month) +
        "-" +
        this.conver(date) +
        " " +
        this.conver(h) +
        ":" +
        this.conver(m) +
        ":" +
        this.conver(s);
      return now;
    },
    //日期时间处理
    conver(s) {
      return s < 10 ? "0" + s : s;
    },
    CompareDate(t1, t2) {
      var date = new Date();
      var a = t1.split(":");
      var b = t2.split(":");
      return date.setHours(a[0], a[1]) > date.setHours(b[0], b[1]);
    },
    onConfirm(time) {
      var ee = this.getDate(time).split(' ')[1]
      var ff = '08:59:59'
      if (this.CompareDate(ee, ff) == false) {
        this.$toast.success("请选择九点之后的时间");
        return;
      }
      this.showPicker = false;
      this.form.appointmentTime = this.getDate(time);
    },
    isSameDay(dateA, dateB) {
      const { getFullYear, getMonth, getDate } = Date.prototype
      return [getFullYear, getMonth, getDate].every(fn => {
        return fn.call(dateA) === fn.call(dateB)
      })
    },
    positionTime(time) {
      var time1 = this.form.appointmentTime.replace(/-/g, '/');
      var oDate1 = new Date(time1);
      var oDate2 = new Date(time);
      if (oDate1) {
        if (oDate1.getTime() > oDate2.getTime()) {
          this.$toast.success("预约仪器时间不得早于预约门诊时间!");
          return; //第一个大
        }
        if (this.isSameDay(oDate1, oDate2) == false) {
          this.$toast.success("预约仪器时间不得超过当天!");
          return; //第二个大
        }
      }
      findInstrumentFlag({
        instrumentName: this.form.AppointmentProject[this.projectIndex].instrumentName,
        instrumentId: this.form.AppointmentProject[this.projectIndex].projectInstrument[0].instrumentId,
        positionId: this.positionRadio,
        instrumentDate: this.getDate(time)
      })
        .then((res) => {
          console.log(res.result)
          if (res.result == true) {
            this.$toast.success("选择仪器使用时间成功");
            this.form.AppointmentProject[this.projectIndex].appointmentPosition[this.projectIdx].useTime =
              this.getDate(time);
            this.addAppointment = true;
            this.showInstrucmentTime = false;
            // 选中仪器携带时间
            let dateTimeNow = this.form.AppointmentProject[this.projectIndex].appointmentPosition[this.projectIdx]
              .useTime.split(' ')[1]
            this.form.AppointmentProject[this.projectIndex].appointmentPosition[this.projectIdx].positionNameTime =
              this.form.AppointmentProject[this
                .projectIndex].appointmentPosition[this.projectIdx].positionName + '(' + dateTimeNow + ')'
            this.$nextTick(() => {
              window.scrollTo({
                top: this.scrollTop,
                behavior: "smooth",
              });
            });
          } else if (res.result == false) {
            this.$toast.success(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.success(err.errMsg);
        });
    },
    // 时间间隔过滤,时间间隔五分钟
    filter(type, options) {
      if (type === 'minute') {
        return options.filter((option) => option % 5 === 0);
      }
      return options;
    },
    dialogConfirm() {
      this.showInstrucmentTime = true;
    },
    // 日期组件日期格式化
    formatter(type, val) {
      if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      } else if (type === "year") {
        return `${val}年`;
      } else if (type === "hour") {
        return `${val}时`;
      } else if (type === "minute") {
        return `${val}分`;
      }
      return val;
    },
    // 跳转选择详情
    enterPart(item, index, idx) {
      this.showTime = false
      //记录滚动位置
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(this.scrollTop);
      // console.log(item, index);
      // form的index
      this.projectIndex = index;
      this.projectIdx = idx;
      // 点击时携带的数字
      this.projectItem = item;
      if (this.projectItem == 4) {
        if (!this.form.appointmentTime) {
          this.$toast.success("请先填写预约门诊时间");
          return;
        } else if (!this.form.AppointmentProject[index].areaName) {
          this.$toast.success("请先填写院区");
          return;
        } else if (!this.form.AppointmentProject[index].floorName) {
          this.$toast.success("请先填写楼层");
          return;
        } else {
          this.addAppointment = false;
          this.flag = true;
          this.flag1 = false;
          this.flag2 = false;
          this.flag3 = false;
          this.flag4 = false;
          this.radio = "";
          this.value = ''
          this.placeholderValue = "请搜索项目";
          this.form.AppointmentProject[index].positionNameTime = ''
          this.form.AppointmentProject[index].instrumentName = ''
          this.form.AppointmentProject[index].doctorName = ''
          this.form.AppointmentProject[index].appointmentPosition = [{
            positionId: '',
            positionName: '',
            positionNameTime: '',
            useTime: '',
          }]
          this.findprojectList('');
        }
      } else if (this.projectItem == 0) {
        console.log(this.form.AppointmentProject[this.projectIndex].id)
        console.log(this.form.AppointmentProject[this.projectIndex].projectId)
        if (!this.form.AppointmentProject[this.projectIndex].id || this.form.AppointmentProject[this.projectIndex].id == undefined) {
          this.$toast.success("请先选择项目");
          return;
        }
        this.instrucmentList = []
        this.addAppointment = false;
        this.flag = false;
        this.flag1 = true;
        this.flag2 = false;
        this.flag3 = false;
        this.flag4 = false;
        this.form.AppointmentProject[this.projectIndex].instrumentName = ''
        this.form.AppointmentProject[this.projectIndex].doctorName = ''
        this.instrucRadio = ''
        this.instrucRadioList = ''
        this.value1 = ''
        this.placeholderValue = "请搜索仪器";
        this.form.AppointmentProject[this.projectIndex].appointmentPosition = [{
          positionId: '',
          useTime: '',
          positionName: '',
          positionNameTime: '',
        }]
        // 跳转选择仪器
        findProjectBydId({
          id: this.form.AppointmentProject[this.projectIndex].id,
          areaCode: this.form.AppointmentProject[this.projectIndex].areaCode,
          floorCode: this.form.AppointmentProject[this.projectIndex].floorCode
        }).then((res) => {
          if (res.result == true) {
            this.projectData = res.data;
            // this.instrucmentList = res.data.instrumentNames.split(",");
            this.instrucmentList = res.data.projectInstrument;
          }
        });
      } else if (this.projectItem == 2) {
        // 跳转选择操作人
        console.log(this.form.AppointmentProject[this.projectIndex].id)
        console.log(this.form.AppointmentProject[this.projectIndex].projectId)
        if (!this.form.AppointmentProject[this.projectIndex].id || this.form.AppointmentProject[this.projectIndex].id == undefined) {
          this.$toast.success("请先选择项目");
          return;
        }
        if (this.form.AppointmentProject[this.projectIndex].projectInstrument.length == 0) {
          this.$toast.success("请先选择仪器");
          return;
        }
        this.doctorList = []
        this.addAppointment = false;
        this.flag = false;
        this.flag1 = false;
        this.flag2 = true;
        this.flag3 = false;
        this.flag4 = false;
        this.form.AppointmentProject[this.projectIndex].doctorName = ''
        this.doctorRadio = ''
        this.doctorRadioList = ''
        this.value2 = ''
        this.placeholderValue = "请搜索操作人";
        findProjectBydId({
          id: this.form.AppointmentProject[this.projectIndex].id,
          areaCode: this.form.AppointmentProject[this.projectIndex].areaCode,
          floorCode: this.form.AppointmentProject[this.projectIndex].floorCode
        }).then((res) => {
          if (res.result == true) {
            console.log(res.data);
            this.projectData = res.data;
            this.doctorListAdd = res.data.projectDoctor;
            // 根据选择仪器时间筛选操作人
            let arrForm = []
            this.doctorListAdd.forEach(ele => {
              arrForm.push(ele.doctorId)
            });
            console.log(arrForm)
            findDoctorByInstrumentDate({
              appointmentTime: this.form.appointmentTime,
              doctorIds: arrForm,
              instrumentId: this.form.AppointmentProject[this.projectIndex].projectInstrument[0].instrumentId,
              appointmentPosition: this.form.AppointmentProject[this.projectIndex].appointmentPosition
            }).then((res) => {
              if (res.result == true) {
                let resData = res.data
                // 筛选id相同的医生数据
                if (resData.length != 0) {
                  console.log('resData.length')
                  console.log(resData.length)
                  console.log(resData)
                  let add = this.doctorListAdd.filter(item => resData.some(ele =>
                    ele.doctorId === item.doctorId))
                  add.push({
                    doctorId: '999999',
                    doctorName: '无指定操作人'
                  })
                  this.doctorList = add
                  console.log('this.doctorList')
                  console.log(this.doctorList)
                } else if (resData.length == 0) {
                  this.doctorList = [{
                    doctorId: '999999',
                    doctorName: '无指定操作人'
                  }]
                }
              }
            });
          } else {
            this.$toast.fail(res.errMsg);
          }
        });
      } else if (this.projectItem == 1) {
        console.log(this.form.AppointmentProject[this.projectIndex].projectInstrument)
        if (this.form.AppointmentProject[this.projectIndex].projectInstrument.length == 0) {
          this.$toast.success("请先选择仪器");
          return;
        }
        this.positionRadio = this.form.AppointmentProject[this.projectIndex].appointmentPosition[this.projectIdx]
          .positionId
        console.log('this.form.AppointmentProject[this.projectIndex].positionId')
        console.log(this.form.AppointmentProject[this.projectIndex])
        this.positionRadioList = this.form.AppointmentProject[this.projectIndex].appointmentPosition[this.projectIdx]
          .positionName
        this.placeholderValue = "请搜索部位";
        this.addAppointment = false;
        this.flag = false;
        this.flag1 = false;
        this.flag2 = false;
        this.flag3 = true;
        this.flag4 = false;
        console.log('当前条下的仪器idthis.instrucRadio')
        console.log(this.form.AppointmentProject[this.projectIndex].instrumentId)
        // 根据仪器id查找部位
        findInstrumentById({
          instrumentId: this.form.AppointmentProject[this.projectIndex].projectInstrument[0].instrumentId
        })
          .then((res) => {
            console.log(res.data.InstrumentPosition);
            if (res.result == true) {
              this.$nextTick(() => {
                this.positionList = res.data.InstrumentPosition
                this.positionList.map((x, i) => {
                  this.form.AppointmentProject[this.projectIndex].appointmentPosition.map((s) => {
                    if (x.positionId === s.positionId) {
                      x.disabled = true
                    }
                  })
                })
                this.$forceUpdate()
                // 筛选仪器部位已经使用的时间
                findInstrumentDateById({
                  appointmentTime: this.form.appointmentTime,
                  instrumentId: this.form.AppointmentProject[this.projectIndex].projectInstrument[0].instrumentId,
                })
                  .then((res) => {
                    console.log(res.data)
                    if (res.result == true) {
                      let dataTimeAppoint = res.data
                      if (dataTimeAppoint.unoccupied) {
                        this.showTime = true
                        this.successAppointTime = dataTimeAppoint
                      } else if (!dataTimeAppoint.unoccupied) {
                        this.showTime = false
                      }
                    }
                    this.$forceUpdate()
                  })
              });
            } else {
              console.log(res.errMsg)
              this.$toast.fail(res.errMsg);
            }
          })
          .catch((err) => {
            console.log(err);
            this.$toast.fail(err.errMsg);
          });
      }
    },
    // 查询项目接口
    findprojectList(projectName) {
      findByProjectIdList({
        projectName: projectName,
        projectType: this.form.projectType,
        areaType: localStorage.getItem('areaType'),
        cityCode: localStorage.getItem('cityCode'),
      })
        .then((res) => {
          if (res.result == true) {
            var cities = res.data;
            this.form.AppointmentProject.map((x, i) => {
              cities.map((s, i) => {
                if (x.id === s.projectId) {
                  cities.splice(i, 1);
                }
              })
            })
            this.$forceUpdate()
            let cityName = {};
            //循环26个字母的数组
            this.FirstPin.forEach(item => {
              cityName[item] = [];
              cities.forEach(el => {
                //对比开头字母是否对应
                let first = pinyin.getFullChars(el.projectName).substring(0, 1).toUpperCase();
                var regNumber = /\d+/; //验证0-9的任意数字最少出现1次。
                // var regString = /[a-zA-Z]+/; //验证字母
                if (regNumber.test(first) == true) {
                  el.projectName = el.projectName.slice(0, 0) + '#' + el.projectName.slice(0)
                }
                if (first == item) {
                  cityName[item].push(el);
                }
              });
            });
            this.$nextTick(() => {
              this.textList = cityName
            })
          } else {
            this.$toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 确定提交参数
    sureAdd() {
      this.addAppointment = true;
      this.form.AppointmentProject[this.projectIndex].id = this.radio;
      findProjectBydId({
        id: this.radio,
        areaCode: this.form.AppointmentProject[this.projectIndex].areaCode,
        floorCode: this.form.AppointmentProject[this.projectIndex].floorCode
      })
        .then((res) => {
          if (res.result == true) {
            console.log(res.data);
            this.projectData = res.data;
            // 新增时部位回显
            if (this.form.AppointmentProject) {
              this.form.AppointmentProject[this.projectIndex].projectName =
                this.projectData.projectName;
              this.form.AppointmentProject[this.projectIndex].hmProjectName =
                this.projectData.hmProjectName;
            }
          } else {
            this.$toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.$nextTick(() => {
        window.scrollTo({
          top: this.scrollTop,
          behavior: "smooth",
        });
      });

    },
    // 确定添加仪器
    addInstrucment() {
      this.addAppointment = true;
      this.showInstrucmentTime = false;
      this.form.AppointmentProject[this.projectIndex].instrumentName =
        this.instrucRadioList;
      console.log(this.instrucRadio)
      this.$nextTick(() => {
        window.scrollTo({
          top: this.scrollTop,
          behavior: "smooth",
        });
      });
      this.form.AppointmentProject[this.projectIndex].projectInstrument = [{
        instrumentId: this.instrucRadio
      }]
    },
    // 确定添加操作人
    addDoctor() {
      this.form.AppointmentProject[this.projectIndex].doctorName =
        this.doctorRadioList;
      console.log(this.doctorRadio)
      if (this.doctorRadio == '') {
        this.$toast.success("请选择操作人");
        return;
      } else {
        this.addAppointment = true;
      }
      this.form.AppointmentProject[this.projectIndex].projectDoctor = [{
        doctorId: this.doctorRadio
      }]
      this.$nextTick(() => {
        window.scrollTo({
          top: this.scrollTop,
          behavior: "smooth",
        });
      });
    },
    // 确定添加部位
    addposition() {
      if (this.positionRadio == '') {
        this.$toast.success("请选择部位");
        return;
      } else {
        // this.addAppointment = true;
        this.showInstrucmentTime = true;
      }
      this.form.AppointmentProject[this.projectIndex].appointmentPosition[this.projectIdx].positionName =
        this.positionRadioList;
      this.form.AppointmentProject[this.projectIndex].appointmentPosition[this.projectIdx].positionId =
        this.positionRadio;
      this.dateFlag = true
      this.showOrHide(this.form.AppointmentProject[this.projectIndex].projectName)
    },
    // 仪器部位时间选择器切换
    showOrHide(projectName) {
      let ss = projectName.includes('热拉提')
      let vv = projectName.includes('热玛吉')
      if (ss == true || vv == true) {
        this.dateFlag = !this.dateFlag
      } else {
        this.dateFlag = true
      }
    },
    // 添加项目
    addProject() {
      this.form.AppointmentProject.push({
        projectName: "",
        instrumentName: "",
        doctorName: "",
        positionName: "",
        key: Date.now(),
        projectInstrument: [],
        projectDoctor: [],
        operationStatus: "",
        appointStatus: "",
        remark: "",
        showTime: false,
        successAppointTime: '',
        positionNameTime: "",
        appointmentPosition: [{
          positionId: '',
          useTime: '',
          positionName: '',
          positionNameTime: '',
        }],
      });
    },
    // 添加至草稿箱
    addDraft() {
      if (!this.form.customerName || this.form.customerName == "") {
        this.$toast.success("请填写顾客名称");
        return;
      }
      if (!this.form.mobile || this.form.mobile == "") {
        this.$toast.success("请填写电话号码");
        return;
      }
      if (!this.form.appointmentTime || this.form.appointmentTime == "") {
        this.$toast.success("请填写预约时间");
        return;
      }
      this.form.AppointmentProject.forEach(ele => {
        ele.operationStatus = 3;
        ele.projectId = ele.id
        if (ele.appointStatusList == '初诊') {
          ele.appointStatus = 0
        } else if (ele.appointStatusList == '复诊') {
          ele.appointStatus = 1
        } else if (ele.appointStatusList == 'VIP') {
          ele.appointStatus = 2
        }
      });
      this.empId = JSON.parse(localStorage.getItem('userInfo')).empId
      this.form.userId = this.empId
      this.form.draftsId = this.draftsId
      this.form.areaType = this.areaType
      this.form.areaCode = this.areaType
      console.log(this.form)
      saveAppointmentDrafts(this.form)
        .then((res) => {
          if (res.result == true) {
            this.$toast.success(res.data);
            this.$router.push("/index");
            this.$toast.clear();
          } else {
            console.log(res.errMsg)
            this.$toast.fail(res.errMsg);
            this.$toast.clear();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.fail(err.errMsg);
          this.$toast.clear();
        });
    },
    // 提交预约
    sureSubmit() {
      if (!this.form.customerName || this.form.customerName == "") {
        this.$toast.success("请填写顾客名称");
        return;
      }
      if (!this.form.mobile || this.form.mobile == "") {
        this.$toast.success("请填写电话号码");
        return;
      }
      if (!this.form.appointmentTime || this.form.appointmentTime == "") {
        this.$toast.success("请填写预约时间");
        return;
      }
      this.form.draftsId = this.draftsId
      this.form.AppointmentProject.forEach(ele => {
        ele.operationStatus = 3;
        ele.projectId = ele.id
        if (ele.appointStatusList == '初诊') {
          ele.appointStatus = 0
        } else if (ele.appointStatusList == '复诊') {
          ele.appointStatus = 1
        } else if (ele.appointStatusList == 'VIP') {
          ele.appointStatus = 2
        }
      });
      this.empId = JSON.parse(localStorage.getItem('userInfo')).empId
      this.form.userId = this.empId
      console.log(this.form);
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "努力加载中..."
      });
      var that = this
      // / 重复预约识别
      let projectIdList = []
      this.form.AppointmentProject.forEach(ele => {
        projectIdList.push(ele.projectId)
      });
      let sureData = {
        mobile: this.form.mobile,
        customerName: this.form.customerName,
        projectId: projectIdList.toString(), // 项目id集合
        appointmentId: '',// 修改时必传
        status: 1,// 1：新增 2：修改
        appointmentTime: this.form.appointmentTime.split(' ')[0]
      }
      if (sureData.projectId == '') {
        _g.toast("warning", "请填写完整项目")
        return;
      }
      if (!this.form.projectType || this.form.projectType == null || this.form.projectType == 'null') {
        this.form.projectType = ''
      } else {
        this.form.projectType = this.form.projectType
      }
      this.form.areaType = localStorage.getItem('areaType')
      this.form.areaCode = localStorage.getItem('areaType')
      findDistinguishData(sureData).then((res) => {
        this.$toast.clear();
        if (res.data != 0) {
          Dialog.confirm({
            message: '该客户在当前时间已预约过此项目,是否确定要重复预约？',
            confirmButtonColor: '#108EE9'
          }).then(() => {
            that.insertOrUpdateList(this.form)
          }).catch(() => {
            // on cancel
          });
        } else if (res.data == 0) {
          that.insertOrUpdateList(this.form)
        }
      })
    },
    insertOrUpdateList(data) {
      insertOrUpdateAppointment(data)
        .then((res) => {
          if (res.result == true) {
            if (res.data != '' && res.data != '已预约（0)次') {
              Dialog.alert({
                message: res.data,
                confirmButtonColor: '#108EE9'
              }).then(() => {
                this.$router.push("/index");
              }).catch(() => {
              });
            } else {
              this.$router.push("/index");
            }
          } else {
            console.log(res.errMsg)
            this.$toast.fail(res.errMsg);
            this.$toast.clear();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.fail(err.errMsg);
          this.$toast.clear();
        });
    },
    // 返回添加预约
    returnIndexList() {
      this.addAppointment = true;
    },
    onSelectType(item) {
      // 默认情况下点击选项时不会自动收起
      this.typeShow = false;
      this.form.projectTypeName = item.name;
      this.form.projectType = item.id;
      // 预约项目类型修改后清空数据
      this.form.AppointmentProject = [{
        projectName: "",
        instrumentName: "",
        doctorName: "",
        operationStatus: "",
        appointStatus: "",
        projectInstrument: [],
        projectDoctor: [],
        remark: "",
        positionNameTime: '',
        appointmentPosition: [{
          positionId: '',
          useTime: '',
          positionName: '',
          positionNameTime: '',
        }],
      },]
      this.form.AppointmentProject.forEach(item => {
        if (this.areaType == 'bsl') {
          item.areaCode = 'bsl'
          item.areaName = '伯思立'
        } else if (this.areaType == 'fls') {
          item.areaCode = 'fls'
          item.areaName = '翡立思'
          item.floorCode = '1'
          item.floorName = '1楼'
        } else if (this.areaType == 'ntbsl') {
          item.areaCode = 'ntbsl'
          item.areaName = '南通伯思立'
          item.floorCode = '1'
          item.floorName = '1楼'
        }
      });
    },
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      this.show = false;
      console.log(item);
      this.form.AppointmentProject[this.checkIndex].appointStatusList = item.name;
      this.form.AppointmentProject[this.checkIndex].appointStatus = item.id;
    },
    checkArea(index) {
      this.areaIndex = index
    },
    checkFloor(index) {
      this.floorIndex = index
      if (this.areaType == 'bsl') {
        this.showFloor = true;
      } else if (this.areaType == 'fls') {
        this.showFloor = false;
      }
    },
    onFloor(item) {
      console.log(item, this.floorIndex)
      this.showFloor = false;
      this.form.AppointmentProject[this.floorIndex].floorCode = item.id
      this.form.AppointmentProject[this.floorIndex].floorName = item.name
      // 楼层值变化的时候清空数据
      this.form.AppointmentProject[this.floorIndex].positionNameTime = ''
      this.form.AppointmentProject[this.floorIndex].instrumentName = ''
      this.form.AppointmentProject[this.floorIndex].doctorName = ''
      this.form.AppointmentProject[this.floorIndex].appointmentPosition = [{
        positionId: '',
        positionName: '',
        positionNameTime: '',
        useTime: '',
      }]
      this.form.AppointmentProject[this.floorIndex].projectName = ''
    },
    onArea(item) {
      console.log(item, this.areaIndex)
      this.showArea = false;
      this.form.AppointmentProject[this.areaIndex].areaCode = item.id
      this.form.AppointmentProject[this.areaIndex].areaName = item.name
    },
    // 选择项目关键字查询
    searchInput(val) {
      if (this.flag = true) {
        console.log(val)
        this.findprojectList(val);
      }
    },
    // 新增部位
    addDomain(index) {
      console.log(this.form.AppointmentProject)
      console.log(index)
      this.form.AppointmentProject[index].appointmentPosition.push({
        positionId: '',
        positionName: '',
        positionNameTime: '',
        useTime: '',
        key: Date.now()
      });
      this.$forceUpdate()
    },
    // 删除部位
    removeDomain(item, idx, listIndex) {
      var index = this.form.AppointmentProject[listIndex].appointmentPosition.indexOf(item)
      if (index !== -1) {
        this.form.AppointmentProject[listIndex].appointmentPosition.splice(idx, 1)
      }
      this.$forceUpdate()
    },
  },

};

</script>
<style scoped>
@import "../../assets/css/addAppointment.css";
@import "../../assets/css/selectPart.css";

.addAppointment>>>.van-radio__icon--checked .van-icon {
  background-color: #ffffff !important;
  color: #108ee9 !important;
  width: 1.31rem;
  border: none;
  height: 1.31rem;
}

.addAppointment>>>.van-field--disabled .van-field__label {
  color: #777777;
}

.addAppointment>>>.van-field__control:disabled {
  color: #777777 !important;
  -webkit-text-fill-color: #777777;
}

.addAppointment>>>.van-radio__icon .van-icon {
  border: none;
  position: absolute;
  right: 3.5rem;
}

.vanIcon {
  position: absolute;
  left: 1.3rem;
}

.radioGroup {
  margin: 0 16px;
}

.addAppointment>>>.van-tag {
  margin: 0.2rem;
}

.textRadio {
  color: #ff6640;
  font-size: 14px;
  line-height: 24px;
}

.dangerButton {
  float: right;
  margin-top: 1rem;
  margin-right: 1rem;
}

.addArrow>>>.van-cell {
  width: 80%;
}

.floorArea>>>.van-cell {
  padding: 0 !important;
  box-sizing: border-box;
}

.floorArea {
  border-bottom: 1px solid #4f89ea;
  width: 95%;
  padding: 0.7rem 0;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/page/copyAddAppointment.vue